module.exports = __webpack_public_path__ + "img/icon_packup.dbdbe84e.svg";